module.exports = __webpack_public_path__ + "files/9abfb210f557ce5e7425ad8f57ea002a.png";